<template>
  <section class="pr-32.5 mx-66">
    <sectionHeader v-if="headerIndex" :text="content[headerIndex]" />
    <div class="content flex flex-col gap-7.5">
      <div v-for="contentPart in Object.entries(content)" :key="contentPart[0]">
        <textElement v-if="contentPart[0].includes('textElement')" :text="contentPart[1]"/>
        <numberedList v-else-if="contentPart[0].includes('numberedList')" :items="contentPart[1]"/>
        <markedList v-else-if="contentPart[0].includes('markedList')" :items="contentPart[1]"/>
        <miniMarkedList v-else-if="contentPart[0].includes('miniMarkedList')" :items="contentPart[1]"/>
      </div>
    </div>
  </section>
</template>

<script>
import sectionHeader from "@/components/desktop/blog/postElements/sectionHeader";
import textElement from "@/components/desktop/blog/postElements/textElement";
import numberedList from "@/components/desktop/blog/postElements/numberedList";
import miniMarkedList from "@/components/desktop/blog/postElements/miniMarkedList";
import markedList from "@/components/desktop/blog/postElements/markedList";

export default {
  name: "postSection",
  props: ['content'],
  components:{sectionHeader, textElement, numberedList, markedList, miniMarkedList},
  computed:{
    headerIndex(){
      let result = null
      Object.keys(this.content).forEach(key => {
        if (key.includes('sectionHeader')){
          result = key
        }
      })
      return result
    }
  }
}
</script>

<style scoped>

</style>